const landing_page = {
  aboutUs: "Về chúng tôi", // translated 
  topPackages: "Các gói hàng đầu", // translated 
  featuredHotels: "Khách sạn nổi bật", // translated 
  topTours: "Các tour du lịch hàng đầu", // translated 
  whatOurMembersSay: "Những gì thành viên của chúng tôi nói...", // translated 
  followUsOnInstagram: "Theo dõi chúng tôi trên Instagram", // translated 
  pleaseWait: "Vui lòng chờ...", // translated 
  packages: "Gói hàng", // translated 
  ourPartners: "Đối tác của chúng tôi", // translated 
  trustedCarHirePartners: "Đối tác cho thuê xe đáng tin cậy", // translated 
  learnMore: "Tìm hiểu thêm", // translated 
};


export default landing_page;
